<div class="container-fluid mt-topnav">
  <div class="row mt-3 pt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <h6 class="">Admin Tools</h6>
              <p class="mb-0">Here you can manage the platform.</p>
              <button class="btn mr-2 cursor-pointer" data-toggle="modal" data-target="#createorg">
                <p class="mb-0 btn-text cursor-pointer">Create Org</p>
              </button>
              <button class="btn m-2 cursor-pointer" data-toggle="modal" data-target="#editorg">
                <p class="mb-0 btn-text cursor-pointer">Edit Org</p>
              </button>
              <!---  <button class="btn m-2 cursor-pointer">
                <p class="mb-0 btn-text cursor-pointer">Create User</p>
              </button>
              <button class="btn m-2 cursor-pointer">
                <p class="mb-0 btn-text cursor-pointer">Create Customer</p>
              </button>-->
              <button class="btn m-2 cursor-pointer" data-toggle="modal" data-target="#editstyle">
                <p class="mb-0 btn-text cursor-pointer">Edit styles</p>
              </button>
              <button class="btn m-2 cursor-pointer" data-toggle="modal" data-target="#modalintegrations">
                <p class="mb-0 btn-text cursor-pointer">Integrations</p>
              </button>
            </div>
            <div class="col-auto">
              <div style="width: 2px; height:100%; background-color: #f2f2f2;"></div>
            </div>
            <div class="col-auto">
              <h6 class="">Daily Stats</h6>
              <p class="mb-0">Organisation based daily stats.</p>
            </div>
            <div class="col-auto">
              <app-uniquelogincounter></app-uniquelogincounter>
            </div>
            <div class="col-auto">
              <div class="card">
                <div class="card-body pl-2 pr-2 pb-0 pt-0">
                  <div class="row mr-0">
                    <div class="col pr-0">
                      <p class="f-35 mb-0 pr-2">10</p>
                    </div>
                    <div class="col pl-0 pr-0">
                      <p class="c-close mb-0 pt-2" style="margin-bottom:-20px!important;">5</p>
                      <span class="material-icons c-close align-middle cursor-default lh-40 pt-1">
                        trending_down
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <p class="text-muted">Pageviews</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <app-uniqueloginchart></app-uniqueloginchart>
        </div>
      </div>
    </div>
  </div>
  <!-- LOGS ------------------------ 
 organizationId:string;
    logtype:string; 
    timeISO:string;
    loguser:string;
    message:string;
    logurl:string;-->
  <div class="row mt-3">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <h6 class="">Log History</h6>
          <p class="mb-0">Organisation based log history.</p>
          <a class="cursor-pointer float-right" style="position: absolute; top:21px; right:10px; z-index: 1;"
            data-toggle="collapse" href="#searchlogCollapse">
            <span class="material-icons portal-icon cursor-pointer p-1 rounded">
              search
            </span></a>
          <div class="row collapse" id="searchlogCollapse">
            <div class="col mr-4">
              <form class="form-horizontal">
                <div class="form-group">
                  <div class="">
                    <input class="form-input form-control" type="text" id="globalSearch" (input)="onChange($event)"
                      placeholder="Search Logs" />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <ngx-table #table [configuration]="configuration" [data]="logs" [columns]="columns">
          </ngx-table>
        </div>
      </div>
    </div>
  </div>

  <!-- create Modal -->
  <div class="modal fade" id="createorg" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Create Organisation</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-orgadd [modalmode]="true"></app-orgadd>
        </div>
      </div>
    </div>
  </div>

  <!-- edit Modal -->
  <div class="modal fade" id="editorg" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Edit Organisation</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-orgedit [modal]="true"></app-orgedit>
        </div>
      </div>
    </div>
  </div>

  <!-- style Modal -->
  <div class="modal fade" id="editstyle" tabindex="-1" role="dialog">
    <app-orgstyle [admin]="true"></app-orgstyle>
  </div>

  <!-- Integrations Modal -->
  <div class="modal fade" id="modalintegrations" tabindex="-1" role="dialog" aria-labelledby="modalintegrationsztitle">
    <app-integrationsettings></app-integrationsettings>
  </div>